export default {
  'emailMessageTrace.title': 'Manage Email Traces',
  'emailMessageTrace.id': 'ID',
  'emailMessageTrace.hideFilter': 'Hide Filters',
  'emailMessageTrace.showFilter': 'Advanced Filters',
  'emailMessageTrace.startDate': 'Start Date',
  'emailMessageTrace.endDate': 'End Date',
  'emailMessageTrace.select.type': 'Select Type',
  'emailMessageTrace.event': 'Event',
  'emailMessageTrace.events': 'Events',
  'emailMessageTrace.processInstance': 'Request',
  'emailMessageTrace.to': 'To',
  'emailMessageTrace.from': 'From',
  'emailMessageTrace.select.event': 'Select Event',
  'emailMessageTrace.select.user': 'Select User',
};
